<div #container class="d-flex align-items-stretch" style="flex: 1" [ngClass]="{'mb-0': modalOptions.fullScreen || showInReport, 'card': !showInReport, 'report-view': showInReport}">
    <ng-container *ngIf="!showInReport">
        <div class="card-header dropdown">
            <h4 class="card-header-title">
                <img src="assets/images/icons/leaf.png" width="20px" class="me-2">
                Energy compass
            </h4>
            <button *ngIf="!modalOptions.fullScreen" type="button" class="btn" role="button" (click)="openModal()"><i class="bi bi-arrows-angle-expand"></i></button>
            <app-chart-download-button [element]="container" [tableElement]="tableElement"></app-chart-download-button>
            <button type="button" class="btn" role="button" (click)="toggleShowAsTable()"><i class="bi" [ngClass]="options.showAsTable ? 'bi-bar-chart-line' : 'bi-table'"></i></button>
            <button type="button" class="btn" role="button" data-bs-toggle="dropdown"
                    data-bs-auto-close="outside" aria-expanded="false">
                <i class="bi bi-three-dots-vertical"></i>
            </button>
            <div class="dropdown-menu overflow-y-auto" style="z-index: 1050; max-height: 60vh;" (change)="saveSettings()">
                <div><h4 class="dropdown-header">Energy labels</h4></div>
                <div class="dropdown-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('show-unknown')"
                               [checked]="settings.showUnknown" (click)="toggleShowUnknown()">
                        <label class="form-check-label" [for]="getInputId('show-unknown')">
                            <span>Show unknown </span>
                            <span class="notranslate"> ({{numberOfUnknownLocations}})</span>
                        </label>
                    </div>
                </div>
                <div><h4 class="dropdown-header">Building types</h4></div>
                <div *ngFor="let plottedBuildingType of plottedBuildingTypes" class="dropdown-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId(plottedBuildingType.buildingTypeId)"
                               [checked]="settings.shownBuildingTypes[plottedBuildingType.buildingTypeId]" (click)="togglePlottedBuildingType(plottedBuildingType)">
                        <label class="form-check-label" [for]="getInputId(plottedBuildingType.buildingTypeId)">
                          <span> {{plottedBuildingType.info.name}} </span>
                           <span class="notranslate"> ({{plottedBuildingType.numberOfLocations}}) </span>
                        </label>
                    </div>
                </div>
            </div>
            <button *ngIf="modalOptions.fullScreen" type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()"></button>
        </div>
    </ng-container>
    <div class="chart-body pt-0 d-flex align-items-stretch mh-100" [ngClass]="{'p-0': options.showAsTable, 'card-body': !showInReport}">
        <ng-container *ngIf="showInReport else notInReport">
            <ng-container [ngTemplateOutlet]="chart"></ng-container>
            <app-energy-compass-table class="w-100 h-100 d-flex align-items-stretch flex-column"
                                      [dataProvider]="chartDataProvider" [settings]="settings" [energyLabels]="energyLabels"></app-energy-compass-table>
        </ng-container>
        <ng-template #notInReport>
            <app-energy-compass-table class="w-100 h-100 d-flex align-items-stretch flex-column" [ngClass]="{'d-none': !options.showAsTable}"
                                      [dataProvider]="chartDataProvider" [settings]="settings" [energyLabels]="energyLabels"
                                      (tableElement)="tableElement = $event"></app-energy-compass-table>
            <ng-container *ngIf="!options.showAsTable">
                <ng-container [ngTemplateOutlet]="chart"></ng-container>
            </ng-container>
        </ng-template>
    </div>
</div>

<ng-template #chart>
    <app-scatter-chart class="chart chart-appended h-100 w-100" [xLabels]="energyLabels" [yLabels]="weiiLabels"
                       [dataProvider]="chartDataProvider" [fullScreen]="modalOptions.fullScreen"
                       [visibleBuildingTypes]="visibleBuildingTypes" [plugins]="plugins" [pluginOptions]="pluginOptions"
                       [gridLineColor]="gridLineColor" [suggestedMinY]="suggestedMinY" [scales]="scales"></app-scatter-chart>
</ng-template>
